module.exports = __webpack_public_path__ + "assets/img/icon_1.44a1bf04.png";